export default __webpack_public_path__ + "static/media/widget.9e6f2c3d.png";